export default {
      id: "credibility-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#credibility",
      toString: function () {
        return this.url;
      }
    }